module.exports = "<div class=\"payments\">\n\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page/payment/payment.html
// module id = 1188
// module chunks = 3